<script lang="ts">
  // Takes the remaining height in a template's column and hands its size to the graphic inside,
  // so charts and maps grow or shrink with the fields around them.
  export let minHeight = 120
  let width = 0
  let height = 0
</script>

<div class="xr-fill" style="min-height: {minHeight}px; flex: 1 1 0;" bind:clientWidth={width} bind:clientHeight={height}>
  {#if width > 0 && height > 0}
    <div class="xr-inner">
      <slot {width} {height} />
    </div>
  {/if}
</div>

<style>
  .xr-fill {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
  }
  .xr-inner {
    position: absolute;
    inset: 0;
  }
</style>
